﻿import React, { useEffect } from 'react';
import { NavLink } from "react-router-dom";
import { DocumentType, NoteType } from '../models/enums';
import RawMaterialsAnalyticalPlansData from './RawMaterialsAnalyticalPlansData';
import RawMaterialBenchSheetData from './RawMaterialBenchSheetData';
import DocumentLoader from './DocumentLoader';
import NoteViewer from './NoteViewer';
import { DocumentationConstants } from '../store/documentation-constants';
import DmaFooter from './DmaFooter';

import { Button } from 'devextreme-react/button';

let key = 0;

export default function RawMaterialAnalysisForm() {
    useEffect(() => {
        initializeUI();
    }, []);

    key++;

    const parts = window.location.href.split('/');
    const rawMaterialBatchId = parts[parts.length - 1];

    return (
        <div className="pw-content">
            <div className="lq-title-bar">
                <div className="lq-main-title">Raw Material Analysis</div>
                <div className="title-bar-spacer" />

                <div className="save-toolbar">
                    <div>
                        <NavLink to={`/documentation/${DocumentationConstants.RawMaterialAnalysis}`}
                            className="pw-right-align-content" target="_blank" rel="noopener noreferrer">
                            <Button className="title-bar-button pw-orange"
                                text="" icon="help" type="normal"
                                hint="help and documentation" />
                        </NavLink>
                    </div>
                </div>
            </div>

            <div id="tab-buttons-panel" className="tab-buttons-container">
                <div id="mainPanelButton" className="tab-button" onClick={onPanelButtonClick}><span className="material-symbols-outlined tab-icon pw-blue">hdr_weak</span> Main</div>
                <div id="analyticalPlansPanelButton" className="tab-button" onClick={onPanelButtonClick}><span className="material-symbols-outlined tab-icon pw-blue">assignment</span> Analytical Plan</div>
                <div id="benchSheetsPanelButton" className="tab-button" onClick={onPanelButtonClick}><span className="material-symbols-outlined tab-icon pw-blue">assignment</span> Bench Sheets</div>
                <div id="notesPanelButton" className="tab-button" onClick={onPanelButtonClick}><span className="material-symbols-outlined tab-icon pw-blue">edit_note</span> Notes</div>
            </div>

            <div id="mainPanel">
                <div>MAIN PANEL DATA (WIP)</div>
            </div>

            <div id="analyticalPlansPanel" className="">
                <div className="pw-margin-bottom-05 pw-margin-top-05">
                    <RawMaterialsAnalyticalPlansData rawMaterialBatchId={rawMaterialBatchId}
                        isReadOnly={false} />

                    <div className="pw-margin-top-1 pw-margin-bottom-1">
                        <div className="lq-header">
                            <div className="lq-header-title">Monographs</div>
                        </div>
                        <DocumentLoader parentId={rawMaterialBatchId}
                            documentType={DocumentType.AnalyticalPlanMonograph }
                            readOnly={false} canDelete={true} />
                    </div>

                    <DmaFooter />

                </div>
            </div>

            <div id="benchSheetsPanel" className="pw-form-section">
                <RawMaterialBenchSheetData
                    rawMaterialBatchId={rawMaterialBatchId} isReadOnly={false} />

                <DmaFooter />
            </div>

            <div id="notesPanel" className="tab-full-width">
                <div className="pw-comp-row-scroll-fixed-grid">
                    <NoteViewer height='30rem' title="Raw Material Analysis Notes"
                        noteType={NoteType.BatchPlanning} parentId={rawMaterialBatchId} />
                </div>
            </div>

        </div>
    );

    function onPanelButtonClick(e: any) {
        resetAllButtons();

        let id: string = e.target.id;

        if (e.target.tagName === "SPAN") {
            id = e.target.parentElement.id;

            const button = e.target.parentElement as HTMLDivElement;

            if (button)
                button.className = "tab-button-active";
        }
        else {
            const button = e.target as HTMLDivElement;

            if (button)
                button.className = "tab-button-active";
        }

        hideAllComponents();

        const panel = document.getElementById(id.replace("Button", "")) as HTMLDivElement;
        if (panel)
            panel.style.display = "";
    }

    function resetAllButtons() {
        const mainPanelButton = document.getElementById("mainPanelButton") as HTMLDivElement;
        mainPanelButton.className = "tab-button-inactive";
                
        const analyticalPlansPanelButton = document.getElementById("analyticalPlansPanelButton") as HTMLDivElement;
        analyticalPlansPanelButton.className = "tab-button-inactive";

        const benchSheetsPanelButton = document.getElementById("benchSheetsPanelButton") as HTMLDivElement;
        benchSheetsPanelButton.className = "tab-button-inactive";

        const notesPanelButton = document.getElementById("notesPanelButton") as HTMLDivElement;
        notesPanelButton.className = "tab-button-inactive";
    }

    function hideAllComponents(onload: boolean = false) {
        if (!onload) {
            const mainPanel = document.getElementById("mainPanel") as HTMLDivElement;
            if (mainPanel)
                mainPanel.style.display = "none";
            else
                return;
        }

        const analyticalPlansPanel = document.getElementById("analyticalPlansPanel") as HTMLDivElement;
        if (analyticalPlansPanel)
            analyticalPlansPanel.style.display = "none";

        const benchSheetsPanel = document.getElementById("benchSheetsPanel") as HTMLDivElement;
        if (benchSheetsPanel)
            benchSheetsPanel.style.display = "none";
            
        const notesPanel = document.getElementById("notesPanel") as HTMLDivElement;
        if (notesPanel)
            notesPanel.style.display = "none";
    }

    function initializeUI() {
        hideAllComponents(true);

        const mainPanelButton = document.getElementById("mainPanelButton") as HTMLButtonElement;
        mainPanelButton.click();
    }


}
